import { computed, onMounted, ref, type Ref } from 'vue';
import { ssoClient } from '~/services';
import { isVerifiedEmailDomain } from '~/utils/emailDomain';

export const outsideVerifiedDomainsMessage = (domains: string[]): string =>
    `This team requires SSO, so invitations can only go to a verified email domain (${domains.join(', ')}).`;

export function useVerifiedEmailDomains(teamId: number, email: Ref<string>) {
    const requireSso = ref(false);
    const domains = ref<string[]>([]);
    const loaded = ref(false);

    onMounted(async () => {
        try {
            const { data } = await ssoClient.getVerifiedDomains(teamId);
            requireSso.value = data.require_sso;
            domains.value = data.domains;
        } catch {
            // a failed lookup must not block inviting; the server still enforces the verified domains
        } finally {
            loaded.value = true;
        }
    });

    const willUseSso = computed(() => email.value !== '' && isVerifiedEmailDomain(email.value, domains.value));
    const blocked = computed(() => loaded.value && requireSso.value && email.value.includes('@') && !willUseSso.value);
    const blockedMessage = computed(() => (blocked.value ? outsideVerifiedDomainsMessage(domains.value) : ''));

    return { blocked, blockedMessage, willUseSso };
}
